import { useTranslation } from "react-i18next";

import { AccessibleSvg } from "@/modules/theme/components/AccessibleSvg";

import { createPasswordInputStyles } from "../helpers/createPasswordInputStyles";
import { ReactComponent as EyeClosed } from "../icons/eye-closed.svg";
import { ReactComponent as EyeOpen } from "../icons/eye-open.svg";

export function ToggleVisibilityButton({
  isVisible,
  togglePasswordVisibility,
}: {
  isVisible: boolean;
  togglePasswordVisibility: () => void;
}) {
  const { t } = useTranslation("layouts/Common/ToggleVisibilityButton");
  const classes = createPasswordInputStyles();
  return (
    <button
      onClick={togglePasswordVisibility}
      className={classes.root}
      type="button"
    >
      {isVisible ? (
        <AccessibleSvg
          title={t("Hide password icon")}
          description={t("It hides the password")}
          SvgComponent={EyeClosed}
          className={classes.icon}
        />
      ) : (
        <AccessibleSvg
          title={t("Show password icon")}
          description={t("It shows the password")}
          SvgComponent={EyeOpen}
          className={classes.icon}
        />
      )}
    </button>
  );
}
